export const deleteForm = formId => async ({
  getState,
  setState
}, {
  api
}) => {
  const {
    permissions
  } = getState();
  if (!permissions.delete) {
    return Promise.reject(new Error('no permissions to delete'));
  }
  setState({
    isIndexLoading: true
  });
  try {
    await api.deleteForm(formId);
    const deletedFormIndexItem = getState().formIndex.find(formIndex => formIndex.id === formId);
    setState({
      formIndex: getState().formIndex.filter(formIndexItem => formIndexItem.id !== (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id))
    });
    return deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.projectFormId;
  } finally {
    setState({
      isIndexLoading: false
    });
  }
};